<script>
import TilesetServices from "./TilesetServices.vue"

export default {
    name: "TilesetsServices",
    components: {
        TilesetServices
    },
}

</script>
<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import tilesets-services
</style>
